import { usePost } from "../../api";

export function useCreatePaymentIntent() {
  const post = usePost();

  return async (partnerId: string, subscriptionId: string) => {
    const response = await post(
      `/api/v3/portal/partners/${partnerId}/subscriptions/${subscriptionId}/payment_methods/setup_intent`
    );

    return toSetupIntent(response);
  };
}

interface SetupIntentResponse {
  clientSecret: string;
}

function toSetupIntent(
  response?: any
): { data: SetupIntentResponse } | undefined {
  const data = response?.data;

  if (data) {
    return {
      data: {
        clientSecret: data.client_secret,
      },
    };
  }
}
